import React from 'react';
import HomeTwoSingleSlide from '../../../components/HomeTwoSingleSlide/HomeTwoSingleSlide';
import Slider from "react-slick";
import ParticleBackground from '../../../components/ParticleBackground/ParticleBackground';

const HomeTwoHeroSlider = () => {
   // slider setting
   const settings = {
      autoplay: true,
      autoplaySpeed: 8000,
      speed: 500,
      infinite: true,
      dots: false,
      fade: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
   };

    return (
        <>
          <section className="slider__area slider__area-2" style={{ position: 'relative', overflow: 'hidden' }}>
             {/* Particle Background */}
             <ParticleBackground id="hero-particles" variant="light" />

             <Slider className='slider-active' {...settings}>

                <HomeTwoSingleSlide
                  slider_class="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1 col-md-10 offset-md-1 col-sm-12"
                  content_class="slider__content-3 text-center"
                  attr_1={<span style={{ background: "gray", color: "white", borderRadius: "5px", padding: "2px 5px" }}>VectorTechSol</span>}
                  attr_2={<h1>Powering Telecom, Digital, and Business Enablement Across the U.S.</h1>}
                  attr_3={
                    <div>
                      <div className="mb-20" style={{ fontSize: '20px', fontWeight: '600', letterSpacing: '1px' }}>
                        Reliable • Compliant • Scalable
                      </div>
                      <div style={{ fontSize: '16px', lineHeight: '1.8' }}>
                        Internet | Voice | TV | Small Business | Call Center Solutions | Digital Marketing
                      </div>
                    </div>
                  }
                  btn_text="Get Started"
                />

             </Slider>

          </section>
        </>
    );
};

export default HomeTwoHeroSlider;